module.exports = __webpack_public_path__ + "static/media/0210_IMG_LA_COQUE.67f19e47.webp";